/* globals cpac, Class, Windows */

if (typeof cpac !== 'undefined') {
  cpac.confirmObject = null;
  cpac.confirmClass  = Class.create({
      initialize: function( title, content, onYes, onNo, addHeight ) {
          this.win = null;
          this.title = title ? title : 'Confirmation';
          this.content = content ? content : '';
          this.onYes = onYes ? onYes : function(){};
          this.onNo  = onNo  ? onNo  : function(){};
          this.addHeight = addHeight == undefined ? 0 : addHeight;
      }
      ,_initWindow: function() {
          this.win = Windows.getWindow(cpac.confirmObject);
          if(!this.win) {
              var title = this.title;
              var addHeight = 0;
              if( this.content.length * 10 > 600 ) {
                  addHeight = Math.round( this.content.length / 60 ) * 15;    // 15px line height, 60 symbols in one row
                 // addHeight = Math.round( 60 / this.content.length ) * 12;    
              }
              if (this.addHeight) {
                  addHeight += this.addHeight;
              }
              this.win = new Window({
                  className: 'alphacube',
                  title: title,
                  width: 350,
                  height: 100 + addHeight,
                  closable: true,
                  resizable: false,
                  minimizable: false,
                  maximizable: false,
                  destroyOnClose: true,
                  zIndex: 10000
              });
              cpac.confirmObject = this.win.getId();
  
              var formContainer = this.win.getContent();
              var html = [
                  '<div style="padding: 10px; padding-top: 20px; font-family: Arial; font-size: 12px; letter-spacing: 0px;">',
                      this.content,
                  '</div>',
                  '<div style="width: 225px; margin: 10px auto;">',
                      '<input type="button" value="No"  class="button nicebutton" style="float: right; width: 100px;" />',
                      '<input type="button" value="Yes" class="button nicebutton" style="float: left; width: 100px;" />',
                  '</div>'
              ].join('');
              formContainer.insert(html);
  
              var btnNo = formContainer.down('.button', 0);
              if(btnNo) {
                  btnNo.observe('click', function(){
                      Windows.close( this.win.getId() );
                      this.onNo();
                  }.bind(this));
              }
              var btnYes = formContainer.down('.button', 1);
              if(btnYes) {
                  btnYes.observe('click', function() {
                      Windows.close( this.win.getId() );
                      this.onYes();
                  }.bind(this));
              }
              return true;
          }
          return false;
      }
      ,showForm: function() {
          if( this._initWindow() ) {
              this.win.showCenter(true);
              //setTimeout('Windows.getWindow(cpac.confirmObject).updateHeight()', 100);
          }
      }
  });
  cpac.confirm = function( text, onYes, onNo, addHeight ) {
      var w = new cpac.confirmClass( null, text, onYes, onNo, addHeight );
      w.showForm();
  }
}